import React from 'react';
import {
  ElementProps,
  SsnInputElementClass,
} from 'types/documentTemplateElement';
import SSNInput from '../../inputs/SSNInput';
import {buildLabel, checkError} from 'utils/elementUtils';
import {useIsDocumentElementDisabled} from '../../../hooks/useIsDocumentElementDisabled';

interface SsnInputElementProps extends ElementProps<SsnInputElementClass> {}

const SsnInputElementComponent: React.FC<SsnInputElementProps> = ({
  element,
  updateElement,
  mode,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (mode === 'view') {
      const newUpdatedElement = new SsnInputElementClass({
        ...element,
        properties: {
          ...element.properties,
          value: e.target.value,
        },
      });
      updateElement(newUpdatedElement);
    }
    if (mode === 'admin') {
      const newUpdatedElement = new SsnInputElementClass({
        ...element,
        properties: {
          ...element.properties,
          value: e.target.value,
        },
      });
      updateElement(newUpdatedElement);
    }
    return;
  };

  const disabled = useIsDocumentElementDisabled(element, mode);

  let containerClass = 'w-full m-8';
  if (mode === 'view' || mode === 'preview' || mode === 'admin') {
    containerClass = element.properties.showLabel
      ? 'w-full mx-3 mb-2'
      : 'w-full mt-5 mx-3 mb-2';
  }

  return (
    <div className={containerClass}>
      <>
        <SSNInput
          id={element.id}
          error={checkError(element, mode) === ''}
          label={buildLabel(element)}
          value={element.properties?.value || ''}
          onChange={handleChange}
          isClickDisabled={mode === 'preview'}
          required={element.properties.required}
          disabled={disabled}
        />
      </>
    </div>
  );
};

export default SsnInputElementComponent;
